import { HashLink } from "react-router-hash-link";
import H1Base from "../../../components/ui/titles/H1Base";
import Button from "../../../components/ui/buttons/Button";
import { REGISTER_DIRECT_STATE } from "../../../constants/register";

const cycleNodes = [
    {
        label: "Offre de prêt",
        sub: "Dès 20 €",
        position: "left-1/2 top-[7%] -translate-x-1/2 text-center",
    },
    {
        label: "Allocation",
        sub: "Diversifiée, tous secteurs",
        position: "right-[2%] top-1/2 -translate-y-1/2 text-right",
    },
    {
        label: "Remboursements",
        sub: "Mensualités",
        position: "bottom-[6%] left-1/2 -translate-x-1/2 text-center",
    },
    {
        label: "Réinvestissement",
        sub: "Rotation des fonds",
        position: "left-[2%] top-1/2 -translate-y-1/2 text-left",
    },
];

const InvestHero = () => {
    return (
        <section className="flex flex-col items-center gap-12 md:flex-row">
            <div className="order-2 flex-1 text-center md:order-1 md:text-left">
                <p className="mb-5 text-sm font-semibold text-secondary">
                    <span className="mr-2.5 inline-block h-1.5 w-1.5 rounded-full bg-accent align-middle" />
                    Financement participatif aux entreprises depuis 2015
                </p>

                <H1Base
                    text="L'épargne qui finance, concrètement, les entrepreneurs français"
                    className="text-3xl leading-tight md:text-4xl lg:text-5xl"
                />

                <p className="mt-6 text-lg leading-relaxed text-gray-600 md:max-w-xl">
                    PretUp met en relation des investisseurs et des PME françaises solides (250 K€ à 20 M€ de
                    chiffre d'affaires, in bonis et profitables) pour financer leur cycle d'exploitation : BFR,
                    recrutement, stocks ou investissement.
                </p>

                <div className="mt-8 flex flex-col items-center gap-5 sm:flex-row sm:flex-wrap md:justify-start">
                    <Button
                        btnType="secondary"
                        hover={true}
                        text="Ouvrir un compte investisseur"
                        link={{ external: false, href: "/inscription/preteur", state: REGISTER_DIRECT_STATE }}
                    />
                    <HashLink
                        to="#parcours"
                        className="border-b-2 border-accent pb-0.5 font-semibold text-secondary transition hover:opacity-70"
                    >
                        Découvrir le parcours investisseur
                    </HashLink>
                </div>
            </div>

            <div className="order-1 flex flex-1 flex-col items-center gap-7 md:order-2">
                <div className="relative h-[300px] w-[300px] flex-shrink-0 rounded-3xl bg-secondaryDark shadow-2xl shadow-secondary/30 sm:h-[380px] sm:w-[380px] lg:h-[440px] lg:w-[440px]">
                    <svg viewBox="0 0 200 200" className="absolute inset-0 m-auto h-[78%] w-[78%] lg:h-[56%] lg:w-[56%]">
                        <circle
                            cx="100"
                            cy="100"
                            r="78"
                            fill="none"
                            stroke="rgba(255,255,255,0.16)"
                            strokeWidth="1.5"
                            strokeDasharray="2 6"
                        />
                        <circle cx="100" cy="30" r="4.5" fill="#fdcb20" />
                        <circle cx="170" cy="100" r="4.5" fill="#fdcb20" />
                        <circle cx="100" cy="170" r="4.5" fill="#fdcb20" />
                        <circle cx="30" cy="100" r="4.5" fill="#fdcb20" />
                    </svg>

                    {cycleNodes.map(({ label, sub, position }) => (
                        <div key={label} className={`absolute hidden w-28 text-sm font-semibold leading-tight text-white lg:block ${position}`}>
                            {label}
                            <span className="mt-0.5 block text-xs font-normal text-secondaryExtraLight">
                                {sub}
                            </span>
                        </div>
                    ))}

                    <div className="absolute inset-0 m-auto flex h-fit w-fit flex-col items-center text-center text-white">
                        <span className="text-4xl font-bold text-accent">24</span>
                        <span className="mt-1 text-xs leading-tight text-secondaryExtraLight">
                            mois en moyenne
                            <br />
                            par prêt
                        </span>
                    </div>
                </div>

                {/* En dessous de lg, la carte est trop etroite pour accueillir les
                    libelles autour du cercle : ils sont repris en legende dessous. */}
                <ul className="grid w-full max-w-[380px] grid-cols-2 gap-x-5 gap-y-3 lg:hidden">
                    {cycleNodes.map(({ label, sub }) => (
                        <li key={label} className="flex items-start gap-2 text-left">
                            <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-accent" />
                            <span className="text-sm font-semibold leading-tight text-secondaryDark">
                                {label}
                                <span className="mt-0.5 block text-xs font-normal text-gray-600">{sub}</span>
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default InvestHero;
